import { render, staticRenderFns } from "./AddCompanyModal.vue?vue&type=template&id=3a7f2f91"
import script from "./AddCompanyModal.vue?vue&type=script&lang=js"
export * from "./AddCompanyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports